/**
 * Iter-236 — Admin Client Insights
 * Route: /admin/insights/clients/:clientId
 * Same component as ClientInsightsRollup but pre-populated with clientId.
 */
import React from 'react';
import { useParams } from 'react-router-dom';
import ClientInsightsRollup from './ClientInsightsRollup';

export default function AdminClientInsights() {
  const { clientId } = useParams();
  return <ClientInsightsRollup asAdmin clientIdOverride={clientId} />;
}
